import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7e4c3096&scoped=true&"
import script from "./detail.js?vue&type=script&lang=js&"
export * from "./detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=7e4c3096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c3096",
  null
  
)

export default component.exports